import { SettingsResponse, SettingsKeys } from 'models/settings'
import { promiseWrapper } from 'utils/promise'

declare let USER_BASE_URL_IK: string

export const fetchSettings = async (keys: SettingsKeys[]): Promise<SettingsResponse> => {
  const url = `${USER_BASE_URL_IK}/api/public/settings?keys[]=${keys.join('&keys[]=')}`
  return promiseWrapper<SettingsResponse, never>(url, 'GET')
}
